import React, { useState, useRef } from 'react';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';

// --- Firebase (คงตามเดิม) ---
const firebaseConfig = {
  apiKey: "AIzaSyBALO-oNqvxmRhTSx9S54A5PIilTrxVOYM",
  authDomain: "refinery-desk-dashboard.firebaseapp.com",
  projectId: "refinery-desk-dashboard",
  storageBucket: "refinery-desk-dashboard.firebasestorage.app",
  messagingSenderId: "28035012838",
  appId: "1:28035012838:web:eb80f171a10371cdbec327"
};
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// ----------------------------------------------------
// Practical Shortcut (cleaned)
// - การ์ด: Title + Caption + ปุ่ม Send
// - Preview ก่อนส่ง (ไม่มีฟอร์มคอนเฟิร์มคิว/แก้คิวอีกแล้ว)
// ----------------------------------------------------
const SHEET_TITLE = 'Frequency Asked Question (Ultraformer III)';

// ✅ กำหนดไอดีการ์ดที่ผูกกับโมดัล (เพิ่มได้ในอนาคต) // กำหนด id ไว้ใช้ให้ตรงกับการ์ดใน SHORTCUTS
// const OLIGIOCALMODAL = 'OLIGIO-CAL';

const SHORTCUTS = [
  //{ id: OLIGIOCALMODAL, title: 'คำนวณราคา Oligio', caption: 'ส่งสรุปอัตโนมัติ', content: '' },
  {
    id: 'ultra-compare', title: 'No Ulthera', caption: 'แจ้งผลลัพธ์และความคุ้ม',
    content: 'ที่คลินิกจะไม่มี Ulthera นะคะ จะมีเป็น Ultraformer III ที่ให้ผลลัพธ์แบบเดียวกับ Ulthera แต่มีความแตกต่างทางด้านราคาเมื่อเทียบกับ Ulthera ถึง 5 เท่าเลยค่ะ'
  },
  {  
  id: 'ultra-shots', title: 'Shot Calculate', caption: 'แจ้งหมอช่วยประเมิน',
  content: 'คุณหมอจะช่วยประเมินจำนวนช็อตให้ หรือ หากคุณลูกค้ามีเรื่องที่อยากเน้นในจำนวนช็อตที่มีตาม Budget สามารถแจ้งได้เลยนะคะ'
  },
];

// ------- LINE / Firestore helpers -------
const logToFirestore = async (text, selectedCustomer) => {
  const latestCustomerInfo = selectedCustomer || {};
  await addDoc(collection(db, 'messages'), {
    from: 'me',
    role: 'me',
    userId: latestCustomerInfo?.userId || '',
    type: 'text',
    customer: text,
    createdAt: serverTimestamp(),
    displayName: latestCustomerInfo.displayName || 'Customer',
    pictureUrl: latestCustomerInfo.pictureUrl || '',
  });
};
const sendToLine = async (userId, text) => {
  const res = await fetch('https://therefineryclinic.herokuapp.com/sendToLine', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId, message: text }),
  });
  const result = await res.json();
  if (!result.success) throw new Error(result.error || 'ส่ง LINE ไม่สำเร็จ');
};

export default function MessageShortcut({ userId, selectedCustomer, onBack }) {
  const [successMessage, setSuccessMessage] = useState('');
  const [previewItem, setPreviewItem] = useState(null);
  const [sendingId, setSendingId] = useState(null);


  // ----- STUB สำหรับตอนที่ยังไม่เปิดใช้ Modal จริง -----
  // NOTE: ถ้าจะใช้โมดัลจริง ให้ไป "ปลดคอมเมนต์" ชุด OLIGIOCALMODAL + state + openModalById
  const openModalById = () => false;   // ตอนนี้ให้คืน false เสมอ ⇒ จะไปแสดง Preview ปกติ
  const isModalShortcut = () => false; // ตอนนี้ไม่มีการ์ดแบบโมดัล ⇒ ปุ่ม Send จะแสดงทุกการ์ด  

  // 👇 state เปิด/ปิดโมดัล (ขยายเพิ่มทีหลังได้)
  // const [showOligioCal, setShowOligioCal] = useState(false);

  const scrollRef = useRef(null);
  const getScrollableParent = (el) => {
    let node = el;
    while (node && node !== document.body) {
      const { overflowY } = window.getComputedStyle(node);
      if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) return node;
      node = node.parentElement;
    }
    return window;
  };
  const scrollToTop = () => {
    const target = getScrollableParent(scrollRef.current);
    (target === window ? window : target).scrollTo({ top: 0, behavior: 'smooth' });
  };

  const sendAndLogText = async (text, idForLock) => {
    try {
      setSendingId(idForLock || 'inline');
      await sendToLine(userId, text);
      await logToFirestore(text, selectedCustomer);
      setSuccessMessage(`ส่งข้อความสำเร็จ:\n${text}`);
      setPreviewItem(null);
      setTimeout(() => setSuccessMessage(''), 1800);
    } catch (err) {
      console.error('❌ LINE ERROR:', err);
      alert('❌ ไม่สามารถส่งข้อความผ่าน LINE ได้');
    } finally {
      setSendingId(null);
    }
  };

  // ✅ ฟังก์ชันเปิดโมดัลตาม id (เพิ่ม case ได้ในอนาคต) // ✅ เพิ่มเคสได้เรื่อย ๆ ตามจำนวน modal
  //const openModalById = (id) => {
  //  switch (id) {
  //    case OLIGIOCALMODAL:
  //      setShowOligioCal(true);
  //      return true;
  //    case HYDRACALMODAL: // ✅ ตัวอย่างที่เพิ่ม
  //      setShowHydraCal(true);
  //      return true;
  //    default:
  //      return false;
  //  }
  //};

  //const isModalShortcut = (id) => [OLIGIOCALMODAL].includes(id); //ถ้ามีหลายโมดัล ก็ขยายลิสต์ให้ครอบทุกไอดี:
  // ตัวอย่าง
  //const HYDRACALMODAL = 'HYDRA-CAL';
  //const PROMONOTEMODAL = 'PROMO-NOTE';

  //const isModalShortcut = (id) => [OLIGIOCALMODAL, HYDRACALMODAL, PROMONOTEMODAL].includes(id);

  // ------- UI -------
  return (
    <div ref={scrollRef} className="relative max-w-screen-xl mx-auto">
      {/* Header */}
      <div className="flex justify-between items-center mt-[-2px] mb-4">
        <div className="flex items-center gap-3">
          <h3 className="text-lg font-semibold">{SHEET_TITLE}</h3>
          <button
            onClick={onBack}
            className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-500 bg-gray-100 hover:bg-gray-200 transition"
          >
            ← Back
          </button>
        </div>
      </div>

      {/* Grid 3 columns */}
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4">
        {SHORTCUTS.map((item) => (
          <div key={item.id} className="border border-gray-200 rounded-xl p-4 bg-white shadow-sm hover:shadow transition">
            <div className="flex items-start justify-between gap-3">
              {/* Title + Caption (คลิกเพื่อ Preview/Modal) */}
              <button
                type="button"
                onClick={() => {
                  // ถ้าเป็นการ์ดที่ผูกโมดัล ให้เปิดโมดัลแทนการ Preview
                  if (openModalById(item.id)) {
                    setPreviewItem(null);
                  } else {
                    setPreviewItem(item);
                  }
                }}
                className="text-left"
                title="Preview หรือเปิดโมดัล"
                aria-label="Preview หรือเปิดโมดัล"
              >
                <div className="text-sm font-semibold leading-snug">{item.title}</div>
                {item.caption && <div className="text-xs text-gray-500 mt-0.5">{item.caption}</div>}
              </button>

              {/* Quick Send (ซ่อนสำหรับการ์ดที่เป็นโมดัล) */}
              {!isModalShortcut(item.id) && (
                <button
                  type="button"
                  onClick={() => sendAndLogText(item.content, item.id)}
                  disabled={sendingId === item.id}
                  className={`px-3 py-1 text-xs rounded-full border transition ${sendingId === item.id ? 'bg-gray-200 text-gray-400 border-gray-200 cursor-not-allowed' : 'border-gray-300 text-gray-700 hover:bg-gray-100'}`}
                  title="ส่งข้อความนี้ทันที"
                >
                  {sendingId === item.id ? 'Sending…' : 'Send'}
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Preview Modal */}
      {previewItem && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl w-[92vw] max-w-[840px] p-5">
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="text-sm font-semibold">{previewItem.title}</div>
                {previewItem.caption && <div className="text-xs text-gray-500">{previewItem.caption}</div>}
              </div>
              <div className="flex items-center gap-2">
                <button onClick={() => setPreviewItem(null)} className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-500 hover:bg-gray-100">✕ Close</button>
              </div>
            </div>

            <div className="mt-4 text-sm text-gray-800 whitespace-pre-line border border-gray-200 rounded-xl p-3 bg-gray-50">{previewItem.content}</div>

            <div className="mt-5 flex items-center justify-end gap-3">
              <button onClick={() => setPreviewItem(null)} className="px-4 py-1 text-sm border border-gray-300 rounded-full text-gray-600 hover:bg-gray-100">Cancel</button>
              <button
                onClick={() => sendAndLogText(previewItem.content, previewItem.id)}
                disabled={sendingId === previewItem.id}
                className={`px-4 py-1 text-sm rounded-full transition ${sendingId === previewItem.id ? 'bg-gray-300 text-white cursor-not-allowed' : 'bg-black text-white hover:opacity-90'}`}
              >
                {sendingId === previewItem.id ? 'Sending…' : 'Send'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ---- Oligio Bundle Modal (เปิดเมื่อกดการ์ด OLIGIOCALMODAL) ---- 
      
      {showOligioCal && (
        <OligioCalModal
          onClose={() => setShowOligioCal(false)}
          onSend={async (text) => {
            await sendAndLogText(text, OLIGIOCALMODAL);
            // โมดัลจะปิดเองจาก onClose ภายในโมดัลหลังส่งสำเร็จ (เผื่อกรณี edge)
            setShowOligioCal(false);
          }}
        />
      )}

      */}

      {/* Success Alert */}
      {successMessage && (
        <div className="fixed inset-0 flex items-center justify-center z-[90]">
          <div className="bg-white shadow-xl rounded-xl px-6 py-4 border border-gray-200 text-center max-w-sm w-[92vw]">
            <div className="text-sm text-gray-800 mb-3 whitespace-pre-line">{successMessage}</div>
            <button onClick={() => setSuccessMessage('')} className="text-xs px-3 py-1 border border-gray-300 rounded-full hover:bg-gray-100 transition text-gray-500">ปิด</button>
          </div>
        </div>
      )}

      {/* Footer Controls */}
      <div className="mt-6 flex justify-between items-center">
        <button onClick={onBack} className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-500 bg-gray-100 hover:bg-gray-200 transition">← Back</button>
        <button onClick={scrollToTop} className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-500 bg-gray-100 hover:bg-gray-200 transition">↑ Top</button>
      </div>
    </div>
  );
}
